module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    attrs: {
      "type": "file",
      "name": "fileUpload"
    },
    on: {
      "change": _vm.onFileChange
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e1f46b8c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-simple-upload/dist/FileUpload.vue
// module id = 172
// module chunks = 1